import type {AxiosRequestConfig} from 'axios';
import {mapKeys, snakeCase} from 'lodash-es';

import {spotheroPost} from 'api';
import {camelizeKeys} from 'utils/format-strings';
import {sendSentryException} from 'utils/error-handling';
import type {
    GetEventDayOverviewResponse,
    EventDayOverview,
} from 'api/events/events.types';

/**
 * Format the response of the Event Venue options.
 */
const formatEventDayOverviewRequest = (facilityIds: number[]) => {
    const formattedData = mapKeys({facilityIds}, (value, key) =>
        snakeCase(key)
    );

    return formattedData;
};

/**
 * Formats the day overview response.
 */
const formatEventDayOverviewResponse = (data: GetEventDayOverviewResponse) => {
    const formattedData = camelizeKeys(data);

    return formattedData;
};

/**
 * Gets the events day overview for a given facility and date.
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Events/get_facilities_facility_id_events-overview_date
 */
const getEventsDayOverview = async (
    facilityIds: number[],
    date: string,
    config: AxiosRequestConfig = {}
) => {
    try {
        const formattedRequest = formatEventDayOverviewRequest(facilityIds);

        const response = await spotheroPost<EventDayOverview>(
            `events/events-overview/${date}/`,
            formattedRequest,
            config,
            false
        );

        const formatedResponse = formatEventDayOverviewResponse(response.data);

        return formatedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventsDayOverview;
